const setToken = (state, token) => {
  state.token = token
  state.isUserLoggedIn = !!token
}

const setUser = (state, user) => {
  state.user = user
}

const setLoader = (state, loader) => {
  state.loader = loader
}

const setSnack = (state, snack) => {
  state.snack = snack;
}

const setType = (state, type) => {
  state.type = type;
}

const setLogin = (state, login) => {
  state.login = login;
}

const setMedia = (state, media) => {
  state.user.media.push(media);
}
const removeMedia = (state) => {
  state.user.media = [];
}

export { setToken, setUser, setLoader, setSnack, setType, setLogin, setMedia, removeMedia }
